// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3jOvt","additionalInfo":"AgreementModal_additionalInfo__dvdnw"};